module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-ja-JP.9eed531e.png";